module.exports = __webpack_public_path__ + "img/card-bg.89ee210.jpg";